import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { lotNegotiationData, selectLot } from './lot.actions';
import { ObservableInput, map, mergeMap, of } from 'rxjs';
import { Lot } from 'src/app/components/bids-and-offers/lots.model';
import { LotDetailsDesktopService } from 'src/app/services/lot-details-desktop.service';
import { NegotiationDetails } from 'src/app/components/negotiations/negotiations.model';

@Injectable()
export class SelectedLotQueryEffect {
  constructor(
    private lotExtensiveDetailsService: LotDetailsDesktopService,
    private actions$: Actions
  ) {}
  // fetches Negotiation data when Lot is selected from data table
  loadSelectedLot$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(selectLot),
      mergeMap((action) => {
        if (
          action.lotDetails._id !== null &&
          action.lotDetails._id !== 'none selected'
        ) {
          return this.lotExtensiveDetailsService
            .watch({ id: action.lotDetails._id })
            .valueChanges.pipe(
              map((queryRes) => {
                // parse through negotiations array to match negotiation lot_id to selected lot_id
                let negotiations: NegotiationDetails[] = null;
                negotiations = queryRes.data.negotiations || [];
                return negotiations.filter(
                  (n) => n.lot_id === action.lotDetails._id
                );
              }),
              map((negotiations) => {
                return lotNegotiationData({ negotiations: negotiations });
              })
            );
        } else {
          return of(
            lotNegotiationData({ negotiations: [] as NegotiationDetails[] })
          );
        }
      })
    );
  });
}
